<template>
    <div class="uk-padding-small uk-flex uk-flex-column" style="height:calc(100% - 10px)">
        <ArchMap :fixedInfo="fixedInfo" style="height:400px"></ArchMap>
        <UniversalDetail :info="fixedInfo"></UniversalDetail>
    </div>
</template>
<script>
import ArchMap from '@/pages/dataBoard/mapMonitor/components/ArchDetail/ArchMap';
import UniversalDetail from '@/pages/dataBoard/mapMonitor/components/ArchDetail/UniversalDetail';
export default {
    props: ['fixedInfo'],
    components: {
        ArchMap,
        UniversalDetail
    },
    mounted() {}
};
</script>

<style scoped lang="scss">
.carrier-img-title {
    padding: 20px 0;
}
</style>
